import script from "./MatchConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MatchConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./MatchConfirmModal.vue?vue&type=style&index=0&id=582502d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582502d6"]])

export default __exports__